export const useEditorSelectionHandlers = ({
  playPauseRef,
  playPause,
  setVerticalLineFor,
  selectionGuideDefaults,
  setClickedTimes,
  setSelectedComponent,
  setLayerId,
  layerCompData,
  setLayerCompData,
  animationObject,
  setLayerIndex,
  layerIndex,
  setIsEditorOn,
  editComponent,
  scrollbarItems,
  setScrollbarItems,
}) => {
  const sendSelectedComponent = (e, index) => {
    if (playPauseRef.current.playPause && playPause.animationCompleted) {
      setVerticalLineFor({ ...selectionGuideDefaults });
      e.stopPropagation();

      if (index === "default") {
        setClickedTimes({ clicks: 0, index: null });
        setSelectedComponent({
          componentType: "default",
          componentStyles: { left: null, top: null },
        });
        setLayerId({
          eventDetails: "",
          type: "",
        });
        return;
      }

      // Nested scrollbar children are indexed against scrollbarItems, not top-level layers.
      const sourceData = editComponent ? scrollbarItems : layerCompData;
      const updateSourceData = editComponent
        ? setScrollbarItems
        : setLayerCompData;

      if (sourceData && index !== undefined) {
        let selectedObj = { ...layerCompData[index] };

        setSelectedComponent(selectedObj);
        let tempIndex = sourceData.findIndex(
          (element) => element.id === selectedObj.id,
        );

        setLayerIndex(tempIndex);
        if (layerIndex !== index) {
          setIsEditorOn("notClickedYet");
        }

        setLayerId({
          eventDetails: "",
          type: "",
        });
      }
    }
  };

  return { sendSelectedComponent };
};
